<template>
  <div class="container">
    <img class="logo" src="@/assets/logo.png" alt="" @click="toHome" />

    <div class="header-item-container">
      <div
        class="header-item"
        v-for="(item, index) in items"
        :key="index"
        v-on:click="handleClickItem(item.path, item.type)"
      >
        {{ item.title }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { useStore } from "vuex";
import { useRouter } from "vue-router";

const store = useStore();
const router = useRouter(); // ✅ 获取 Vue Router 实例

const items = [
  { title: "PDF转Word", path: "/convert-scans-to-editable-docs", type: "pdf" },
  { title: "OCR文字识别", path: "/convert-scans-to-editable-docs", type: "ocr" },
  { title: "表格格式保留", path: "/convert-scans-to-editable-docs", type: "table" },
  { title: "定价", path: "/price" },
  { title: "使用场景", path: "/use-cases" },
  { title: "帮助中心", path: "/faq" },
];

const toHome = () => {
  router.push("/home");
};

const handleClickItem = (path, type) => {
  store.dispatch("clearStore");

  router.push({ path: path, query: { type: type } }); // ✅ 使用 router.push 方法跳转页面
};
</script>

<style lang="less" scoped>
.container {
  z-index: 2001;
  height: 88px;
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  padding: 0 40px;
  justify-content: space-between;

  .logo {
    cursor: pointer;
  }

  .header-item-container {
    display: flex;

    .header-item {
      margin-left: 30px;
      line-height: 88px;
      font-size: 18px;
      color: #222;
      cursor: pointer;
    }
  }
}
</style>